import { baseInstance } from "src/api";

export const getUserStatistics = async () => {
  try {
    return await baseInstance.get(`user/statistics/`);
  } catch (err: any) {
    return err;
  }
};
